// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './PopupList.scss';

const PopupList = ({ className, title, actions, children }) => (
    <div className={classNames('PopupList', className)}>
        {title || actions ? (
            <div className="list-header">
                <span className="list-title">{title}</span>
                <div className="actions">{actions}</div>
            </div>
        ) : null}
        <ul className="popup-list" data-scrollable>
            {children}
        </ul>
    </div>
);

PopupList.propTypes = {
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    actions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default PopupList;
